import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_COURSE_TYPE,
  EXPAND_COURSE_TYPE_MAIN_TREE_KEYS,
  EXPAND_COURSE_TYPE_SUPPORTING_TREE_KEYS,
  FETCH_COURSE_TYPES,
  MOVE_COURSE_TYPES,
  RENAME_COURSE_TYPE,
  RESET_COURSE_TYPE_TREE,
  SET_DATA_FOR_RENAMING_COURSE_TYPE,
} from '../action-types'

export const cleanupFetchCourseTypes = createAction(FETCH_COURSE_TYPES.CLEANUP)
export const addCourseTypeNode = createPayloadAction(ADD_COURSE_TYPE)

export const renameCourseTypeNode = createPayloadAction(RENAME_COURSE_TYPE)
export const resetCourseTypeTree = createAction(RESET_COURSE_TYPE_TREE)
export const moveCourseTypes = createPayloadAction(MOVE_COURSE_TYPES)

export const setDataForRenamingCourseType = createPayloadAction(
  SET_DATA_FOR_RENAMING_COURSE_TYPE,
)

export const expandCourseTypeMainTreeKeys = createPayloadAction(
  EXPAND_COURSE_TYPE_MAIN_TREE_KEYS,
)

export const expandCourseTypeSupportingTreeKeys = createPayloadAction(
  EXPAND_COURSE_TYPE_SUPPORTING_TREE_KEYS,
)
